import { noop } from 'lodash'
import { createContext, useContext } from 'react'

type CampaignCreationContextType = {
  expanded: number | undefined
  setExpanded: (index: number) => void
  handleSelectVoice: (voice?: number) => void
}

export interface BareArticle {
  id: string
  name: string
  emoji: string | null
}

export const CampaignCreationContext = createContext<CampaignCreationContextType>({
  expanded: undefined,
  setExpanded: noop,
  handleSelectVoice: noop,
})

export function useCampaignCreationContext() {
  return useContext(CampaignCreationContext)
}

export class AiCampaignCreationError extends Error {
  errorCode: string
  assessment?: string
  constructor(
    message: string,
    { errorCode, assessment }: { errorCode: string; assessment?: string },
    readonly metadata?: any,
  ) {
    super(message)
    this.name = 'AiErrorFunctionCall'
    this.errorCode = errorCode
    this.assessment = assessment
  }
}
